import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ClinicEnvironmentService } from '../clinic-environment.service';
import { SettingResep } from '../../models/setting-resep.model';
import { SettingResepAdapter } from '../adapter/setting-resep.adapter.service';

@Injectable({
  providedIn: 'root',
})
export class SettingResepApiService implements ApiService<SettingResep> {
  constructor(
    private clinicEnvService: ClinicEnvironmentService,
    private http: HttpClient,
    private adapter: SettingResepAdapter
  ) {}
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public getSetting(): Observable<any> {
    return this.http
      .get(`${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-resep`)
      .pipe(
        map((data: any) => {
          if (!data) {
            return null;
          }
          return this.adapter.adapt(data.responses.settingResep[0]);
        }),
        catchError((err) => throwError(err))
      );
  }

  public create(data: any): Observable<any> {
    return this.http
      .post(
        `${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-resep`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public update(id: number, data: any): Observable<any> {
    return this.http
      .patch(
        `${environment.urlV2}/data-klinik/${this.clinicEnvService.clinicId}/setting-resep/${id}`,
        data,
        this.httpOptions
      )
      .pipe(catchError((err) => throwError(err)));
  }
}
